export default __webpack_public_path__ + "static/media/gallery-wip-handle-cover_03.33b519bd.jpg";